import React, { forwardRef } from 'react';

import { Images } from 'util/images';
import QuillEditor from 'components/QuillEditor/quillEditorEmail';

import {
  FormHeader,
  FormSection,
  Dropdown,
  ArrowDown,
  DropdownItem,
  LanguageDropdownButton,
  LanguageDropdownMenu,
  EmailSubjectInput,
  LanguageDropdownContainer,
  EmailSubjectInputContainer,
  RowContainer,
  LanguageFlag,
  ErrorMessage,
} from './styles';

const EmailSettings = forwardRef(
  (
    {
      emailSettings,
      emailSubject,
      setEmailSubject,
      emailBody,
      setEmailBody,
      activeLanguageIsEnglish,
      setActiveLanguageIsEnglish,
    },
    _ref
  ) => {
    const setEmailLanguage = (isEnglish = true) => {
      if (isEnglish) {
        setEmailSubject(emailSettings?.enSubject);
        setEmailBody(emailSettings?.enHtml);
        setActiveLanguageIsEnglish(true);
      } else {
        setEmailSubject(emailSettings?.svSubject);
        setEmailBody(emailSettings?.svHtml);
        setActiveLanguageIsEnglish(false);
      }
    };

    const updateEmailBody = (updatedValue, delta, source) => {
      let isPlaceholder = false;
      if (delta?.ops) {
        for (const d of delta.ops) {
          if (d.insert) {
            if (d.insert.charAt(0) === '[' && d.insert.charAt(d.insert.length - 1) === ']') isPlaceholder = true;
          }
        }
      }
      // isPlaceholder check is because on adding placeholder source is api
      // Added condition because on tab change values are not updating properly
      if (source !== 'user' && !isPlaceholder) return;
      setEmailBody(updatedValue);
    };

    const renderReactQuill = () => {
      if (emailBody)
        return (
          <QuillEditor
            placeholder="Email template"
            className="quill-email"
            addPlaceholder={true}
            id="emailBodyInput"
            value={emailBody}
            onChange={(updatedValue, delta, source) => updateEmailBody(updatedValue, delta, source)}
          />
        );
    };

    return (
      <FormSection>
        <FormHeader>Email to candidate:</FormHeader>
        <RowContainer>
          <LanguageDropdownContainer>
            <Dropdown>
              <LanguageDropdownButton data-toggle="dropdown">
                <LanguageFlag src={activeLanguageIsEnglish ? Images.enFlag : Images.svFlag} />
                {activeLanguageIsEnglish ? 'English ' : 'Swedish '}
                <ArrowDown />
              </LanguageDropdownButton>
              <LanguageDropdownMenu>
                <DropdownItem onClick={() => setEmailLanguage(false)}>
                  <LanguageFlag src={Images.svFlag} />
                  Swedish
                </DropdownItem>
                <DropdownItem onClick={() => setEmailLanguage()}>
                  <LanguageFlag src={Images.enFlag} />
                  English
                </DropdownItem>
              </LanguageDropdownMenu>
            </Dropdown>
          </LanguageDropdownContainer>
          <EmailSubjectInputContainer>
            <EmailSubjectInput
              id="emailSubjectInput"
              value={emailSubject}
              onChange={(e) => setEmailSubject(e.target.value)}
            ></EmailSubjectInput>
          </EmailSubjectInputContainer>
        </RowContainer>
        {renderReactQuill()}
        {!emailBody.includes('[test-ticket-url]') && (
          <ErrorMessage small noMarginBottom>
            Oops, seems like [test-ticket-url] is missing from the email. Add it again to be able to send the test.
          </ErrorMessage>
        )}
      </FormSection>
    );
  }
);

export default EmailSettings;
